import { useMutation } from '@tanstack/react-query'
import { depositToEarn } from 'services/EarnService'
import { BaseErrorResponse } from 'types/beneficiaries'
import { DepositRequest, DepositTransferResponse } from '../../types'
import { useEarnTracking } from '../useEarnTracking'

export const useDepositPortfolio = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (data: DepositTransferResponse) => void
  onError?: (error: BaseErrorResponse) => void
}) => {
  const { trackSuccess, trackError } = useEarnTracking()
  const { mutate: depositToPortfolio, isPending: isDepositingToPortfolioPending } = useMutation({
    mutationFn: depositToEarn,
  })

  const handleDepositToPortfolio = (data: DepositRequest) => {
    const {
      originator: { walletId, amount },
    } = data

    return depositToPortfolio(data, {
      onSuccess: data => {
        trackSuccess('deposit', {
          walletId,
          amount,
        })
        onSuccess?.(data)
      },
      onError: (error: BaseErrorResponse) => {
        trackError('deposit', error, {
          walletId,
          amount,
        })
        onError?.(error)
      },
    })
  }

  return {
    depositToPortfolio: handleDepositToPortfolio,
    isDepositingToPortfolioPending,
  }
}
